import * as React from 'react';

const Ca16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#E1001F",
    d: "M1 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V5Z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#F1F2F1",
    d: "M3.5 3h9v10h-9V3Zm4.669 8.524-.085-1.498a.154.154 0 0 1 .014-.072.166.166 0 0 1 .046-.06.192.192 0 0 1 .148-.039l1.611.263-.217-.556a.105.105 0 0 1-.004-.068.113.113 0 0 1 .041-.058l1.764-1.323-.397-.172a.118.118 0 0 1-.06-.057.105.105 0 0 1-.004-.08l.349-.993-1.016.2A.13.13 0 0 1 10.278 7a.117.117 0 0 1-.056-.056l-.197-.428-.793.788a.13.13 0 0 1-.144.023.117.117 0 0 1-.054-.051.105.105 0 0 1-.01-.071l.382-1.827-.613.329a.128.128 0 0 1-.17-.047L8 4.528 7.378 5.66a.115.115 0 0 1-.031.036.125.125 0 0 1-.093.025.129.129 0 0 1-.047-.014l-.613-.329.382 1.827a.105.105 0 0 1-.01.07.117.117 0 0 1-.054.052.13.13 0 0 1-.144-.023l-.793-.788-.197.428A.117.117 0 0 1 5.722 7a.13.13 0 0 1-.08.01l-1.017-.2.349.994a.105.105 0 0 1-.004.08.117.117 0 0 1-.06.057l-.397.172 1.764 1.323c.02.015.034.035.04.058a.105.105 0 0 1-.003.069l-.217.555 1.61-.262a.192.192 0 0 1 .149.039.16.16 0 0 1 .06.131l-.085 1.498h.338Z"
  }
));
Ca16.Size = 16;
Ca16.Title = "Ca";

export { Ca16 as default };
